module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-small-2a57535b3b86c31fa30cb0c26a3bc52b.png";